import BackgroundCore from './src/main.vue';
import { withInstall } from '../../utils';
export * from '../../utils/helper/background';
export { default as backGroundHelper } from '../../utils/helper/background';
export const Background = withInstall(BackgroundCore);
export default Background;
